/**
 * ROC 7
 * Copyright 2016 ROC Commerce
 * 
 * Any modifications required of core files should be handled in supplemental files 
 * or duplicates of said core files. This is to assist in upgrade paths.
 */


define('modules/GiftCards/GiftCards',[
    'jquery',
    'global/all',
    './GiftCards.Service',
    './GiftCards.Forms'
], function ($, Roc, GiftCardService, Forms) {
    'use strict';

    var btns = {
        submitPaymentForm: '[data-roc-action="submitGiftCardPaymentForm"]',
        cancelPaymentForm: '[data-roc-action="cancelGiftCardPaymentForm"]',
        removeGiftCardPayment: '[data-roc-action="removeGiftCardPayment"]',
        checkCardBalance: '[data-roc-action="checkCardBalance"]'
    };

    function checkCardBalanceEvent() {
        $(document)
            .off('click', btns.checkCardBalance)
            .on('click', btns.checkCardBalance, function () {

                var isValid = Roc.Validation.validateForm(Forms.CertificatePayment);
                if (isValid) {

                    var request = Roc.Forms.getFormValues(Forms.CertificatePayment);
                    Roc.Core.lockButton(btns.checkCardBalance);
                    GiftCardService
                        .checkCardBalance(request)
                        .always(function () {
                            Roc.Core.releaseLockedButton(btns.checkCardBalance);
                        }).done(function (balance) {
                            var model = {
                                cardNumber: request.cardNumber,
                                balance: balance
                            };
                            Roc.UI.template('#giftCardBalance-Tmp', model).then(function (renderedTemplate) {
                                $('[data-roc-wrapper="gift-certificate-details"]').append(renderedTemplate);
                            });
                            Roc.Forms.clearData(Forms.CertificatePayment);
                        }).fail(function (xhr) {
                            Roc.Logger.error(xhr);
                            Roc.UI.ajaxErrorPopup(xhr);
                        });
                    return;
                }
            });
    }

    function submitPaymentFormEvent() {
        $(document)
            .off('click', btns.submitPaymentForm)
            .on('click', btns.submitPaymentForm, function () {

                var isValid = Roc.Validation.validateForm(Forms.CertificatePayment);
                if (isValid) {

                    var request = Roc.Forms.getFormValues(Forms.CertificatePayment);
                    request.CurrentOrderId = '{orderId}';
                    Roc.Core.lockButton(btns.submitPaymentForm);
                    GiftCardService
                        .submitPayment(request)
                        .always(function () {
                            Roc.Core.releaseLockedButton(btns.submitPaymentForm);
                        }).done(function (resp) {
                            Roc.UI.success('Completed!');
                            Roc.Forms.clearData(Forms.CertificatePayment);
                            Roc.EventManager.notify(Roc.Events.giftCards.ASSOCIATE_PAYMENT, resp);
                        }).fail(function (xhr) {
                            Roc.Logger.error(xhr);
                            Roc.UI.ajaxErrorPopup(xhr);
                        });
                }
            });
    }

    function cancelPaymentFormEvent() {
        $(document)
            .off('click', btns.cancelPaymentForm)
            .on('click', btns.cancelPaymentForm, function () {
                Roc.Forms.clearData(Forms.CertificatePayment);
                return false;
            });
    }

    function removeGiftCardPaymentEvent() {
        $(document)
            .off('click', btns.removeGiftCardPayment)
            .on('click', btns.removeGiftCardPayment, function () {
                var request = {
                    orderId: '{orderId}',
                    paymentId: $(this).attr('data-id')
                };

                GiftCardService
                    .removeGiftCardPayment(request)
                    .done(function (resp) {
                        Roc.UI.success('Completed!');
                        Roc.EventManager.notify(Roc.Events.giftCards.REMOVE_PAYMENT, resp);
                    }).fail(function (xhr) {
                        Roc.Logger.error(xhr);
                        Roc.UI.ajaxErrorPopup(xhr);
                    });

                return false;
            });
    }

    function bindEvents() {
        submitPaymentFormEvent();
        cancelPaymentFormEvent();
        removeGiftCardPaymentEvent();
        checkCardBalanceEvent();
    }

    var GiftCards = {
        bindEvents: bindEvents,
        forms: Forms
    };

    Roc.Logger.debug('GiftCards.js Loaded:', GiftCards);
    return GiftCards;
});
